<!-- Start Page Title Area -->
<div class="page-title-area item-privacy">
    <div class="container">
        <div class="page-title-content">
            <h2>Privacy Policy</h2>
            <ul>
                <li><a routerLink="/">Home</a></li>
                <li>Privacy Policy</li>
            </ul>
        </div>
    </div>

    <div class="lines">
        <div class="line"></div>
        <div class="line"></div>
        <div class="line"></div>
    </div>
</div>
<!-- End Page Title Area -->

<!-- Start project Details Area -->
<div class="projects-details-area ptb-110">
    <div class="container">
        <div class="projects-details">

            <div class="projects-details-desc">
                <h3>Privacy Policy</h3>
                <p>This privacy policy sets out the way in which Althea Soft LTD ("Company") collects, uses, and protects any personal data that you provide when using our services in the United Kingdom. We are committed to protecting your personal data and complying with all applicable data protection laws in the United Kingdom.</p>

                <h3>Data We Collect and Process</h3>
                <p>We may collect and process the following data:</p>
                <p>Personal data such as your name, address, email address, and phone number
                    Health data that you provide to us, such as health status and medical history
                    Technical data such as IP address, browser type, and operating system
                    Usage data such as pages visited, time spent on the website, and referring URL</p>

                <h3>Use of Data</h3>
                <p>We collect and process your personal data for the following purposes:</p>
                <p>To provide our services to you
                    To improve our services and website
                    To send you promotional and marketing communications
                    To comply with applicable laws and regulations</p>
                <p><b>We do not sell or rent your personal data to any third parties.</b></p>

                <h3>Sharing of Data</h3>
                <p>We may share your personal data with third parties in the following circumstances:</p>
                <p>With service providers that provide us with support services
                    With regulatory authorities when required by law or regulation
                    With law enforcement agencies when required by law or regulation</p>

                <h3>Data Retention</h3>
                <p>We will retain your personal data for as long as required to fulfill the purposes for which it was collected or as required by law or regulation.</p>
                
                <h3>Data Security</h3>
                <p>We implement appropriate technical and organizational measures to protect against unauthorized access, accidental loss, or destruction of personal data.</p>
                
                <h3>Your Rights</h3>
                <p>You have the following rights under applicable data protection laws:</p>
                <p>The right to access and obtain a copy of your personal data
                    The right to request correction of your personal data
                    The right to request deletion of your personal data
                    The right to object to the processing of your personal data
                    The right to data portability</p>
                
                <h3>Contact Us</h3>
                <p>If you have any questions or concerns about this privacy policy, or if you would like to exercise any of your rights, please contact us at <b>sales@altheasoft.com</b></p>
                <p>We may update this privacy policy from time to time by posting a new version on our website. You should check this page occasionally to ensure that you are happy with any changes.</p>
                
                <blockquote class="wp-block-quote">
                    <p class="mb-0">Experience the Next Generation of Healthcare with our AI-Driven Tracking System.</p>
                </blockquote>
            </div>
        </div>
    </div>
</div>
<!-- End project Details Area -->